import React from 'react';

export default function MenuRow({ icon, label, value, onClick, variant = 'default', disabled = false }) {
  const isDanger = variant === 'danger';
  const isInteractive = typeof onClick === 'function' && !disabled;

  const handleClick = (e) => {
    if (!isInteractive) return;
    if ('vibrate' in navigator) navigator.vibrate(5);
    onClick(e);
  };

  return (
    <button
      type="button"
      disabled={disabled || !isInteractive}
      onClick={handleClick}
      style={{
        ...styles.row,
        cursor: isInteractive ? 'pointer' : 'default',
        opacity: disabled ? 0.5 : 1,
      }}
    >
      {icon && <span style={styles.icon} aria-hidden>{icon}</span>}
      <span style={{ ...styles.label, color: isDanger ? '#C8442A' : '#1A1A1A' }}>{label}</span>
      <span style={styles.right}>
        {value != null && <span style={styles.value}>{value}</span>}
        {isInteractive && !isDanger && <span style={styles.chevron} aria-hidden>›</span>}
      </span>
    </button>
  );
}

const styles = {
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    width: '100%',
    padding: '14px 16px',
    background: 'transparent',
    border: 'none',
    borderBottom: '1px solid #EDEAE3',
    fontFamily: 'inherit',
    fontSize: 14,
    textAlign: 'left',
  },
  icon: {
    fontSize: 18,
    width: 22,
    flexShrink: 0,
    lineHeight: 1,
  },
  label: {
    flex: 1,
    fontWeight: 500,
  },
  right: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
  },
  value: {
    fontSize: 13,
    color: '#6B6B6B',
    fontWeight: 500,
  },
  chevron: {
    fontSize: 18,
    color: '#9A9A9A',
    lineHeight: 1,
  },
};
